import { Component, ViewChild, ElementRef, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, FormControl, Validators } from '@angular/forms';
import { ModalComponent } from '@bhtp-fork/ng2-bs3-modal/ng2-bs3-modal';
import { EmailQuoteData } from './models/email-quote-data.model';

import { multipleEmailsValidator } from '@bhtp-client-web/component';

@Component({
    selector: 'email-quote-modal',
    template: require('./email-quote-modal.component.html')
})
export class EmailQuoteModal implements OnInit {
    @Output() onEmailQuoteClosed: EventEmitter<EmailQuoteData> = new EventEmitter<EmailQuoteData>();

    @ViewChild('emailQuoteModal')
    public modal: ModalComponent;

    public emailForm: FormGroup;
    public primaryEmail: FormControl;
    public comment: FormControl;
    public submitted: boolean = false;

    constructor() { }

    ngOnInit(): void {
        this.buildForm(null);
    }

    public open(emailQuoteData: EmailQuoteData): void {

        // Sets the forms values
        (<FormGroup>this.emailForm).setValue(emailQuoteData, { onlySelf: true });

        // disables fields
        this.primaryEmail.disable();

        this.modal.open();
    }

    public close(): void {
        this.modal.close();
    }

    public send(): void {
        this.submitted = true;

        if (this.emailForm.valid) {
            this.primaryEmail.enable();
            let resp: EmailQuoteData = (<EmailQuoteData>this.emailForm.value);

            this.modal.close();

            // checks to make sure that there is an event before attempting to emit to it
            if (this.onEmailQuoteClosed) {
                this.onEmailQuoteClosed.emit(resp);
            }
        }
    }

    private buildForm(emailQuoteData: EmailQuoteData): void {
        let formGroup: FormGroup = new FormGroup({});

        this.primaryEmail = new FormControl('');
        formGroup.addControl('primaryEmail', this.primaryEmail);

        this.comment = new FormControl('');
        formGroup.addControl('comment', this.comment);

        this.emailForm = formGroup;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/email-quote/email-quote-modal.component.ts